import { addDays, dayOfWeek, startOfWeekMon, todayInTimezone, type LocalDate } from '@census/shared';

export function todayLocalIso(): string {
  return todayInTimezone('America/New_York');
}

export function startOfWeekMonIso(date: string): string {
  return startOfWeekMon(date as LocalDate);
}

export function addDaysIso(date: string, n: number): string {
  return addDays(date as LocalDate, n);
}

export function dayOfWeekIso(date: string) {
  return dayOfWeek(date as LocalDate);
}

export function fmtTime(min: number): string {
  const h = Math.floor(min / 60);
  const m = min % 60;
  const ampm = h < 12 ? 'AM' : 'PM';
  const h12 = h === 0 ? 12 : h > 12 ? h - 12 : h;
  return `${h12}:${m < 10 ? `0${m}` : m} ${ampm}`;
}

export function fmtDate(iso: string): string {
  const [y, m, d] = iso.split('-').map(Number);
  if (!y || !m || !d) return iso;
  const dt = new Date(Date.UTC(y, m - 1, d));
  return dt.toLocaleDateString('en-US', {
    weekday: 'short',
    month: 'short',
    day: 'numeric',
    timeZone: 'UTC',
  });
}
